module.exports = __webpack_public_path__ + "static/media/history_32.60f1234f.png";